// Single source of truth for all brand/content used on the site.
// Update SITE_URL to the production domain after GoDaddy DNS is live.

export const SITE_URL = "https://5starhandymanfl.com";

export const BUSINESS = {
  name: "5-Star Handyman Service",
  phone: "(239) 880-4931",
  phoneRaw: "+12398804931",
  email: "5starhandyman0@gmail.com",
  city: "Lehigh Acres",
  state: "FL",
  zip: "",
  tagline:
    "Family-owned. 5-star-rated. Built on trust, sawdust, and Southwest Florida sunshine.",
  logo: "https://customer-assets.emergentagent.com/job_frosty-dubinsky-7/artifacts/mtfb07bf_IMG_2764.jpg",
  // Keep the 3 primary targets first — used for SEO headings/copy.
  serviceArea: ["Lehigh Acres", "Fort Myers", "Cape Coral"],
  hours: [
    { day: "Mon – Fri", time: "7:00 AM – 7:00 PM" },
    { day: "Saturday", time: "8:00 AM – 5:00 PM" },
    { day: "Sunday", time: "By appointment" },
  ],
};

// Rich per-city copy for Areas We Serve section (local SEO).
export const AREAS_SERVED = [
  {
    city: "Lehigh Acres, FL",
    slug: "lehigh-acres",
    blurb:
      "Our home base. From Lehigh Acres starter homes to long-time family houses off Sunshine Blvd and Homestead Rd, we handle the fixes that keep piling up — ceiling fans, door replacements, gutter cleanings and everything in between.",
    zipHint: "33936 · 33971 · 33972 · 33973 · 33974 · 33976",
  },
  {
    city: "Fort Myers, FL",
    slug: "fort-myers",
    blurb:
      "Fort Myers homeowners trust us for honest, same-week handyman service — from downtown historic homes to Gateway, Whiskey Creek, and Iona. Licensed, insured, and always cleaner on the way out than on the way in.",
    zipHint: "33901 · 33905 · 33907 · 33908 · 33912 · 33913 · 33916 · 33919 · 33966",
  },
  {
    city: "Cape Coral, FL",
    slug: "cape-coral",
    blurb:
      "We cross the bridge daily for Cape Coral families. Canal-front homes, newer builds off Pine Island Rd, and everything in between — gutter cleanings, door installs, lighting upgrades and storm-season prep.",
    zipHint: "33904 · 33909 · 33914 · 33990 · 33991 · 33993",
  },
];

export const SERVICES = [
  {
    id: "lighting",
    title: "Lighting & Ceiling Fans",
    blurb:
      "Modern pendants, chandeliers and ceiling fans — installed safely and to code. We remove old fixtures, haul them away, and tidy up before we leave. A favorite for Lehigh Acres, Fort Myers and Cape Coral homeowners swapping builder-grade fixtures.",
    image: "/generated/service-lighting.jpg",
    alt:
      "5-Star Handyman installing a modern chandelier in a Southwest Florida foyer — Lehigh Acres, Fort Myers and Cape Coral lighting installation.",
    tag: "Most requested",
  },
  {
    id: "doors",
    title: "Doors — Sales & Installation",
    blurb:
      "Interior, exterior, sliding and storm doors. Perfectly hung, properly sealed, and ready for decades of salty Florida air. We handle door replacement and installation across Lehigh Acres, Fort Myers and Cape Coral.",
    image: "/generated/service-doors.jpg",
    alt:
      "Handyman installing a new white exterior door on a Fort Myers FL home — door replacement service.",
    tag: "Pro install",
  },
  {
    id: "gutters",
    title: "Gutter Cleaning & Services",
    blurb:
      "Storm-season ready. Full gutter clean-outs, re-pitching, minor repairs and downspout clearing across Lehigh Acres, Fort Myers and Cape Coral — keep the Florida rain where it belongs.",
    image: "/generated/service-gutters.jpg",
    alt:
      "5-Star Handyman cleaning gutters on a Cape Coral Florida home with palm trees in the background.",
    tag: "Seasonal",
  },
  {
    id: "repairs",
    title: "General Home Repairs",
    blurb:
      "Drywall patches, caulking, trim, door handles, TV mounts, leaky faucets — the honey-do list, done right the first time. Trusted by hundreds of Southwest Florida homeowners.",
    image: "/generated/service-repairs.jpg",
    alt:
      "Handyman patching drywall in a Lehigh Acres FL home — general home repair services.",
    tag: "Everyday fixes",
  },
];

export const QUICK_SERVICES = [
  "Furniture Assembly",
  "Caulking & Sealing",
  "TV Mounting",
  "Picture Hanging",
  "Screen Repair",
  "Smart Home Install",
  "Drywall Patching",
  "Faucet Replacement",
  "Shelving & Storage",
];

export const TESTIMONIALS = [
  {
    name: "Marguerite D.",
    location: "Lehigh Acres, FL",
    quote:
      "Showed up on time, cleaned up after, and charged exactly what they quoted. Finally a handyman I can keep calling.",
  },
  {
    name: "Rick & Donna P.",
    location: "Fort Myers, FL",
    quote:
      "They replaced two ceiling fans and hung a chandelier in a 20-foot foyer. Real craftsmanship, really kind people.",
  },
  {
    name: "Carlos M.",
    location: "Cape Coral, FL",
    quote:
      "I manage six rental units and these guys handle everything — doors, gutters, you name it. Absolute lifesavers.",
  },
];

export const GALLERY = [
  {
    src: "/generated/gallery-1.jpg",
    alt:
      "Tropical-style ceiling fan installation by 5-Star Handyman Service in Lehigh Acres, FL.",
  },
  {
    src: "/generated/gallery-2.jpg",
    alt:
      "Close-up of door handle installation on a dark wood door — Cape Coral handyman service.",
  },
  {
    src: "/generated/gallery-3.jpg",
    alt:
      "Row of modern pendant lights newly installed above a Fort Myers kitchen island.",
  },
  {
    src: "/generated/gallery-4.jpg",
    alt:
      "Handyman installing a gutter downspout extension at a Southwest Florida home.",
  },
  {
    src: "/generated/gallery-5.jpg",
    alt:
      "Portrait of the owner of 5-Star Handyman Service next to the company work van.",
  },
  {
    src: "/generated/gallery-6.jpg",
    alt:
      "Floating shelf installation in a Fort Myers bedroom — 5-Star Handyman Service.",
  },
];

export const HERO_IMAGE = "/generated/hero.jpg";

// FAQ — used for the on-page FAQ section and FAQPage JSON-LD schema.
export const FAQS = [
  {
    q: "What areas do you serve in Southwest Florida?",
    a:
      "5-Star Handyman Service is based in Lehigh Acres, FL, and proudly serves Lehigh Acres, Fort Myers, and Cape Coral — plus surrounding Lee County neighborhoods. Not sure if we cover you? Call (239) 880-4931 and we'll tell you straight.",
  },
  {
    q: "Are you licensed and insured?",
    a:
      "Yes. We are a fully licensed and insured family-owned handyman service. We carry general liability coverage and operate under all applicable Florida handyman regulations.",
  },
  {
    q: "How much do you charge for a handyman visit?",
    a:
      "Most small jobs start with a flat service fee and scale from there based on time and materials. We give free, no-pressure quotes before we start — and we stick to the number we gave you.",
  },
  {
    q: "How soon can you come out?",
    a:
      "Most Lehigh Acres, Fort Myers, and Cape Coral jobs are booked within the same week — many within 24 to 48 hours. Call or text (239) 880-4931 for same-day availability.",
  },
  {
    q: "Do you install ceiling fans and light fixtures?",
    a:
      "Yes — lighting and ceiling-fan installation is our most-requested service. We remove old fixtures, install new ones safely, and haul away the old hardware at no extra charge.",
  },
  {
    q: "Can you clean gutters on a two-story home?",
    a:
      "Yes. We carry the right ladders and safety gear to clean, re-pitch, and make minor repairs to gutters on both one- and two-story homes in Lehigh Acres, Fort Myers, and Cape Coral.",
  },
  {
    q: "Do you handle storm and hurricane prep?",
    a:
      "Absolutely. From hurricane shutter installs to storm-door replacement, gutter clean-outs, and last-minute storm prep — we help SWFL families get ready every season.",
  },
  {
    q: "How do I get a quote?",
    a:
      "Use the Request a Quote form on this page, or call (239) 880-4931. Most quotes go out the same day.",
  },
];
